import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { LINKS } from "@/lib/links";

const NAV = [
  { name: "MAPPA", href: LINKS.TEMPIO_VIVO },
  { name: "SFIDA DEL DESERTO", href: LINKS.DESERTO },
  { name: "TEMPIO", href: LINKS.TEMPIO_APP },
  { name: "SHOP", href: LINKS.SHOP, gold: true },
  { name: "DONNA", href: LINKS.DONNA_VIRTUOSA },
  { name: "UOMO", href: LINKS.UOMO_BIBLICO },
];

const ext = (href) => (href.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {});

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 bg-[#0B0B0B]/85 backdrop-blur-xl border-b border-[#262626]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="/" data-testid="header-logo" className="flex items-center">
          <span className="block w-40 h-11 sm:w-48 sm:h-[52px] overflow-hidden">
            <img
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_academy-fede/artifacts/47428df050d18dec_WhatsApp_Image_2026-09-30_at_19.05.29.jpg"
              alt="Tempio — Fede & Fitness Italia"
              className="w-full h-full object-cover mix-blend-lighten"
            />
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          <a href="/" data-testid="nav-home" className="nav-link active text-[0.68rem] uppercase tracking-[0.2em] font-medium text-[#F7F4EE]">
            HOME
          </a>
          {NAV.map((l) => (
            <a
              key={l.name}
              href={l.href}
              {...ext(l.href)}
              data-testid={`nav-${l.name.toLowerCase().replace(/ /g, "-")}`}
              className={`nav-link text-[0.68rem] uppercase tracking-[0.2em] font-medium transition-colors flex items-center gap-1 ${
                l.gold ? "text-[#C9A75D] hover:text-[#C9A75D]" : "text-[#F7F4EE]/65 hover:text-[#F7F4EE]"
              }`}
            >
              {l.name}
              {l.gold && <ArrowUpRight size={12} />}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a data-testid="header-cta-app" href={LINKS.APP} {...ext(LINKS.APP)} className="btn btn-gold-fill !py-2.5 !px-4 hidden sm:inline-flex">
            SCARICA L'APP
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-[#F7F4EE] p-2"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden bg-[#0B0B0B] border-b border-[#262626] overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              <a href="/" onClick={() => setOpen(false)} data-testid="mobile-nav-home" className="text-sm uppercase tracking-[0.2em] text-[#F7F4EE]/80">
                HOME
              </a>
              {NAV.map((l) => (
                <a
                  key={l.name}
                  href={l.href}
                  {...ext(l.href)}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${l.name.toLowerCase().replace(/ /g, "-")}`}
                  className={`text-sm uppercase tracking-[0.2em] ${l.gold ? "text-[#C9A75D]" : "text-[#F7F4EE]/80"}`}
                >
                  {l.name}
                  {l.gold && " ↗"}
                </a>
              ))}
              <a href={LINKS.APP} {...ext(LINKS.APP)} onClick={() => setOpen(false)} className="btn btn-gold-fill w-full">
                SCARICA L'APP
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
